(() => {
  document.documentElement.classList.add('virtukart-core-ready');

  const assetUrl = (filename) => {
    const script = document.currentScript || Array.from(document.scripts).find((item) => item.src.includes('virtukart-core.js'));
    if (!script || !script.src) return '';

    return script.src.replace(/virtukart-core\.js(?:\?.*)?$/, filename);
  };

  const hydrateBrandAssets = () => {
    const logo = assetUrl('virtukart-logo.svg');
    const compactLogo = assetUrl('virtukart-logo-compact.svg');
    const favicon = assetUrl('virtukart-favicon.svg');

    if (favicon && !document.querySelector('link[href*="virtukart-favicon.svg"]')) {
      const icon = document.createElement('link');
      icon.rel = 'icon';
      icon.type = 'image/svg+xml';
      icon.href = favicon;
      document.head.appendChild(icon);
    }

    const logoLink = document.querySelector('.header__logo a');
    if (!logoLink || logoLink.querySelector('img')) return;

    logoLink.classList.remove('header__logo--text');
    logoLink.classList.add('header__logo--image', 'header__logo--virtukart');
    logoLink.textContent = '';

    const mobile = document.createElement('img');
    mobile.src = compactLogo || logo;
    mobile.loading = 'eager';
    mobile.width = 132;
    mobile.height = 132;
    mobile.alt = 'VirtuKart';
    mobile.className = 'logo header__logo--mobile md:hidden';

    const desktop = document.createElement('img');
    desktop.src = logo || compactLogo;
    desktop.loading = 'eager';
    desktop.width = 560;
    desktop.height = 132;
    desktop.alt = 'VirtuKart';
    desktop.className = 'logo header__logo--desktop md:block hidden';

    logoLink.append(mobile, desktop);
  };

  const replaceStaleCopy = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const join = (...parts) => parts.join('');
    const replacements = new Map([
      [join('Saving ', '$30 ', 'for Gadgets'), 'Smart everyday finds for Indian homes'],
      [join('Mon-Sat, 9am-6pm ', 'E', 'ST.'), 'Mon-Sat, 10:00 AM - 5:00 PM IST.'],
      [join('+1 888-', '234-1234 (tool-free)'), '+91 9211521711'],
      [join('touch', '@garacestore.com'), 'support@virtukart.shop'],
      [join('382 NE 191st St # 87394 ', 'Mia', 'mi'), 'House No-2409, Sarita Kunj, Delhi Road, Gurgaon, Haryana 122001'],
      [join('COD ', 'clarity'), 'COD where eligible'],
      [join('Eligibility is shown before payment ', 'where available.'), 'COD availability and any handling fee are shown at checkout before payment.'],
      [join('India ', 'delivery'), 'Free India shipping'],
      [join('Delivery options and timelines ', 'appear before checkout.'), 'Free shipping across serviceable Indian pin codes, with most orders delivered in 4-7 business days.'],
      [join('Secure ', 'payments'), 'Secure checkout'],
      [join('Secure ', 'Payment'), 'Secure checkout'],
      [join('UPI, cards, wallets, and ', 'net-banking at checkout.'), 'UPI, cards, net banking, wallets, and COD where eligible.'],
      [join('Policy-led ', 'support'), '14-day eligible returns'],
      [join('Returns and support follow the store policy, ', 'without fake claims.'), 'Unused items in original packaging can be returned within 14 days; damaged or incorrect items must be reported within 48 hours.'],
      [join('Fast ', 'Delivery'), '4-7 day delivery'],
      [join('Support-led ', 'shopping'), 'Mon-Sat support'],
      [join('Delivery across ', 'India'), 'Free India shipping'],
      [join('COD eligibility shown ', 'before payment'), 'COD where eligible'],
      [
        join('COD eligibility, delivery options, ', 'and payment methods are shown before payment. ', 'Returns follow the store policy.'),
        'COD availability and any handling fee are shown at checkout. Free shipping applies across serviceable Indian pin codes, most orders arrive in 4-7 business days, and eligible returns are accepted within 14 days.'
      ],
      [join('Multi-pack offers are shown ', 'before payment where eligible.'), 'Pack pricing and prepaid-only offers are shown clearly before checkout.'],
      [join('COD ', 'clarity before payment'), 'COD shown before payment'],
      [join('Returns follow ', 'store policy'), '14-day eligible returns'],
      [join('COD ', 'clarity, secure checkout, and India ', 'delivery'), 'Free India shipping. Secure checkout. COD where eligible.'],
      [join('COD where eligible, ', 'secure checkout, and Free India shipping'), 'Free India shipping. Secure checkout. COD where eligible.']
    ]);

    while (walker.nextNode()) {
      let nextValue = walker.currentNode.nodeValue;
      for (const [staleCopy, replacementCopy] of replacements) {
        nextValue = nextValue.replaceAll(staleCopy, replacementCopy);
      }
      if (nextValue !== walker.currentNode.nodeValue) {
        walker.currentNode.nodeValue = nextValue;
      }
    }
  };

  const normalizeFooterLegalCopy = () => {
    document.querySelectorAll('a').forEach((link) => {
      if (link.textContent.trim() === 'Brand & Delivery Disclaimer') {
        link.textContent = 'Business & Delivery Disclaimer';
      }
    });

    const copyright = document.querySelector('.footer__copyright-content');
    if (!copyright) return;

    copyright.innerHTML = [
      '&copy; 2026 ',
      '<a class="link-underline" href="https://virtukart.shop/">Virtukart</a>. ',
      'Operated by Kartik Kaushik (Sole Proprietor). ',
      '<a class="link-underline" href="https://www.shopify.com/?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore" rel="nofollow">Powered by Shopify</a>'
    ].join('');
  };

  const normalizeHeaderAndFooterMenus = () => {
    document.querySelectorAll('.topbar__left, .topbar__right').forEach((column) => {
      column.remove();
    });

    document.querySelectorAll('.topbar__center .topbar__text p').forEach((item) => {
      item.textContent = 'Free India shipping. Secure checkout. COD where eligible.';
    });

    const footer = document.querySelector('.footer');
    if (!footer) return;

    footer.querySelectorAll('.footer__info .linklist').forEach((list) => {
      list.remove();
    });

    footer.querySelectorAll('.footer-block--newsletter').forEach((block) => {
      block.remove();
    });

    const footerMenuBlocks = Array.from(footer.querySelectorAll('.footer-block--menu'));
    const seenMenus = new Set();
    footerMenuBlocks.forEach((block) => {
      const signature = Array.from(block.querySelectorAll('a'))
        .map((link) => `${link.textContent.trim()}|${link.getAttribute('href')}`)
        .join('::');

      if (signature && seenMenus.has(signature)) {
        block.remove();
        return;
      }

      if (signature) seenMenus.add(signature);
    });

    const firstHeading = footerMenuBlocks[0]?.querySelector('.footer-block__heading');
    if (firstHeading && firstHeading.textContent.trim() === 'Quick links') firstHeading.textContent = 'Shop & support';
  };

  const hydrateCollectionsPage = async () => {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections') return;
    if (document.body.textContent.includes('Shop VirtuKart categories') && !document.body.textContent.includes('Spoke Cotton Sofas')) return;

    const templateSection = document.querySelector('[id^="shopify-section-template--"]');
    const sectionId = templateSection?.id.replace('shopify-section-', '') || '';
    const templatePrefix = sectionId.includes('__') ? sectionId.split('__')[0] : '';
    if (!templatePrefix) return;

    const response = await fetch(`${window.location.pathname}?sections=${templatePrefix}__main,${templatePrefix}__proof`, {
      credentials: 'same-origin'
    });
    if (!response.ok) return;

    const sections = await response.json();
    const nextMarkup = [sections[`${templatePrefix}__main`], sections[`${templatePrefix}__proof`]].filter(Boolean).join('');
    if (!nextMarkup || !nextMarkup.includes('Shop VirtuKart categories')) return;

    const staleSections = Array.from(document.querySelectorAll(`[id^="shopify-section-${templatePrefix}__"]`));
    const firstSection = staleSections[0];
    if (!firstSection) return;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = nextMarkup;
    firstSection.before(...Array.from(wrapper.children));
    staleSections.forEach((section) => section.remove());
  };

  const hydrateContactPage = async () => {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/contact') return;
    const staleBrandLabel = ['Brand', 'Name'].join(' ');
    if (document.getElementById('VirtuKartContactForm') && !document.body.textContent.includes(staleBrandLabel)) return;

    const templateSection = document.querySelector('[id^="shopify-section-template--"]');
    const sectionId = templateSection?.id.replace('shopify-section-', '') || '';
    const templatePrefix = sectionId.includes('__') ? sectionId.split('__')[0] : '';
    if (!templatePrefix) return;

    const response = await fetch(`${window.location.pathname}?sections=${templatePrefix}__main,${templatePrefix}__form`, {
      credentials: 'same-origin'
    });
    if (!response.ok) return;

    const sections = await response.json();
    const nextMarkup = [sections[`${templatePrefix}__main`], sections[`${templatePrefix}__form`]].filter(Boolean).join('');
    if (!nextMarkup || !nextMarkup.includes('VirtuKartContactForm')) return;

    const staleSections = Array.from(document.querySelectorAll(`[id^="shopify-section-${templatePrefix}__"]`));
    const firstSection = staleSections[0];
    if (!firstSection) return;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = nextMarkup;
    firstSection.before(...Array.from(wrapper.children));
    staleSections.forEach((section) => section.remove());
  };

  const bindStickyCodFallback = () => {
    const ensureStickyCodFallback = () => {
      document.querySelectorAll('.sticky-atc-bar .product-form__button-dynamic').forEach((slot) => {
        if (slot.querySelector('[data-vk-releasit-fallback]')) return;

        const wrapper = slot.querySelector('[data-vk-releasit-buy-now]') || slot;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'vk-releasit-fallback-button';
        button.setAttribute('data-vk-releasit-fallback', '');
        button.textContent = 'COD Order';
        wrapper.appendChild(button);
      });
    };

    ensureStickyCodFallback();
    window.setTimeout(ensureStickyCodFallback, 800);
    window.setTimeout(ensureStickyCodFallback, 2200);

    document.addEventListener('click', (event) => {
      const fallbackButton = event.target.closest('[data-vk-releasit-fallback]');
      if (!fallbackButton) return;

      event.preventDefault();
      const mainReleasitButton = Array.from(
        document.querySelectorAll(
          '.section-main-product .main-product-form [data-vk-releasit-buy-now] ._rsi-cod-form-gempages-button-hook :is(button, a, [role="button"], input[type="button"], input[type="submit"])'
        )
      ).find((button) => {
        const box = button.getBoundingClientRect();
        const styles = window.getComputedStyle(button);
        return box.width > 0 && box.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
      });

      if (mainReleasitButton) {
        mainReleasitButton.click();
        return;
      }

      const mainForm = document.querySelector('.section-main-product .main-product-form');
      if (mainForm) {
        mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bindStickyCodFallback();
      hydrateBrandAssets();
      replaceStaleCopy();
      normalizeFooterLegalCopy();
      normalizeHeaderAndFooterMenus();
      hydrateCollectionsPage();
      hydrateContactPage();
    }, { once: true });
  } else {
    bindStickyCodFallback();
    hydrateBrandAssets();
    replaceStaleCopy();
    normalizeFooterLegalCopy();
    normalizeHeaderAndFooterMenus();
    hydrateCollectionsPage();
    hydrateContactPage();
  }
})();
